import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Iconic Twin Tower designed by Architect Hafeez Contractor",
    "Mumbai's Premiere Club Experience with The Edge Club",
    "Signature Tribeca Decks offer sweeping Arabian Sea Views",
    "Double-Height Lobby with Meeting Lounges, Café & Patisserie",
  ];
  const highlights2 = [
    "Jodi Living Rooms for enjoying breathtaking vistas",
    "A Rooftop with Panaromic Views of Mumbai's Skyline",
    "An Extraordinary Dining Experience beneath the Open Sky",
    "The Most Extensive Amenities in the Market",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Nestled in the cultural heart of Lalbaug-Parel, Tribeca The Edge is not
        just another address - it is a trophy property for those who seek the
        extraordinary. With an iconic double tower design and panoramic views of
        the Arabian Sea and Mumbai skyline, The Edge is redefining luxury,
        elegance, and architectural brilliance in South Mumbai.
        <br />
        Crafted by Tribeca - India's most design-forward real estate developer
        and creators of Trump Towers - and Tejukaya Group, one of India's oldest
        and most reputed infrastructure players, The Edge embodies timeless
        living with infinite attention to detail. From a grand double-height
        hotel-style lobby to world-class rooftop experiences and sky lounges,
        this is not just a home—it's a statement.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
